<template>
<div>
	<Form :label-width="100">
		<Row :gutter="10">
			<Col span="6">
				<FormItem label="参保人员">
					<Input v-model="params.insurantNameOrId" clearable @on-enter="search" placeholder="人员姓名/证件号码"></Input>
				</FormItem>
			</Col>
			<!-- <Col span="6">
				<FormItem label="保障状态">
					<Select v-model="params.insuranceStatus" placeholder="请选择保障状态" clearable >
						<Option value="UNDONE">未完成</Option>
						<Option value="YUSHOUJIAN">待生效</Option>
						<Option value="CHENGBAOJIAN">保障中</Option>
						<Option value="ZHONGZHIJIAN">已失效</Option>
						<Option value="EXCEPTION">异常</Option>
					</Select>
				</FormItem>
			</Col> -->
			<Col span="6">
				<FormItem label="结算状态">
					<Select v-model="params.settlementStatus" placeholder="请选择结算状态" clearable >
						<Option value="WAIT_DONE">待结算</Option>
						<Option value="WAIT_CONFIRM">结算待确认</Option>
						<Option value="OK_DONE">已结算</Option>
					</Select>
				</FormItem>
			</Col> 
			<Col span="6">
				<FormItem label="参保公司">  
					<Select
						v-model="params.companyId"
						filterable
						placeholder="请选择参保公司"
						@on-change="selectCompany" clearable>
						<Option :value="item.companyId" v-for="(item,index) in companyList" :key="item.companyId">{{item.companyName}}</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="参保机构">
					<Select v-model="params.deptId" placeholder="请选择参保机构" clearable>
						<Option :value="item.deptId" v-for="(item,index) in depList" :key="item.deptId">{{item.deptName}}</Option>
					</Select>
				</FormItem>
			</Col>
			
		</Row>
		<Row :gutter="10">
			<Col span="6">
				<FormItem label="起保日期">
					<daterange @on-change="val=>{setDateRange(val,'effectiveDateStart')}" is-fulltime placeholder="请选择起保日期" placement="bottom-end"></daterange>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="终保日期">
					<daterange @on-change="val=>{setDateRange(val,'effectiveDateEnd')}" is-fulltime placeholder="请选择终保日期" ></daterange>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="导入时间">
					<daterange @on-change="val=>{setDateRange(val,'createTime')}" is-fulltime placeholder="请选择导入时间" ></daterange>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="导入类型">
					<Select v-model="params.importType" placeholder="请选择导入类型" clearable>
						<Option value="INIT">首批投保</Option>
						<Option value="ADD">批量增人</Option>
						<Option value="QUIT">退保</Option> 
					</Select>
				</FormItem>
			</Col>
		</Row>
		<Row :gutter="10">
			<Col span="6">
				<FormItem label="数据来源">
					<Select v-model="params.policySource" placeholder="请选择数据来源" clearable>
						<Option value="IMPORT">手动导入</Option>
						<Option value="SYSTEM_SYNC">系统同步</Option> 
					</Select>
				</FormItem>
			</Col>
		</Row>
		<Row :gutter="10">
			<!-- INIT  首次   ADD 批量新增 QUIT 批量退保 -->
			<Col span="16">
				<Dropdown :trigger="isInDisabledTime?'custom':'hover'">
					<Button :disabled="isInDisabledTime" type="info">导入参保人员 <Icon type="ios-arrow-down"></Icon></Button>
					<!-- <Button type="info" @click="toImport('join')">导入参保人员</Button> -->
					<template #list>
						<DropdownMenu>
							<DropdownItem @click.native="toImport('INIT')">年度首批投保</DropdownItem>
							<DropdownItem @click.native="toImport('ADD')">批量增人</DropdownItem>
						</DropdownMenu>
					</template>
				</Dropdown>
				<Button type="success" @click="toImport('QUIT')">导入退保人员</Button>
			</Col>
			<Col span="8" class="right">
				<Button type="info" @click="search">搜索</Button>
				<Button type="primary" @click="excel">导出</Button>
			</Col>
		</Row>
	</Form>
	<p class="totalM mt10">
		参保人员保费合计：{{total}}元
	</p>
	<i-table :columns="columns" url="/guarantee/queryPolicyUser.json" :params="params" ref="table"></i-table>
	<Modal
		v-model="selectCompanyShow"
		title="选择参保公司">
		<Form :label-width="100">
			<!-- <FormItem label="公司名称">
				<Select v-model="importCompany" clearable >
					<Option :value="item.companyId" @click.native="getDepId(item)" v-for="(item,index) in companyList" :key="index" :disabled="(importType=='INIT'&&item.hasAuthPermission!=1)||((importType=='ADD'||importType=='QUIT')&&item.hasAddPermission!=1)">{{item.companyNameNew}}</Option>
				</Select>
			</FormItem> -->
			<FormItem label="公司名称">
				<Select v-model="importCompany" clearable @on-change="selectCompanyMoad" >
					<Option :value="item.companyId" v-for="(item,index) in companyList" :key="index"  :disabled="(importType=='INIT'&&item.hasAuthPermission!=1)||((importType=='ADD'||importType=='QUIT')&&item.hasAddPermission!=1)" >{{item.companyNameNew}}</Option>
				</Select>
			</FormItem>
			<FormItem label="参保机构">
				<Select v-model="depListModId" clearable >
					<Option :value="item.deptId"   v-for="(item,index) in depListMod" :key="item.deptId" :disabled="(importType=='INIT'&&item.hasAuthPermission!=1)||((importType=='ADD'||importType=='QUIT')&&item.hasAddPermission!=1)" >{{item.deptName}}</Option>
				</Select>
			</FormItem>
		</Form>
		<div slot="footer">
			<Button type="default" @click="selectCompanyShow=false">取消</Button>
			<Button type="primary" @click="confirmSelectCompany" :disabled="!Boolean(importCompany)||!Boolean(depListModId)">确定</Button>
		</div>
	</Modal>
</div>
</template> 

<script>
import ITable from '@/components/common/ITable'
import daterange from '@/components/common/daterange'

export default {
	components:{daterange,ITable},
	data () {
		const isInDisabledTime = Date.now()>=Date.parse("2024-01-27 00:00:00")&&Date.now()<=Date.parse("2024-01-31 23:59:59")
		return {
			params:{
				productCode:'JIN_KONG'
			},
			columns:[
				{title: '员工号',key: 'empNo',width:160},
				{title: '手机号',key: 'phone',width:130},
				{title: '姓名',key: 'name',width:120},
				{title: '性别',key: 'genderName',width:80},
				{title: '证件类型',key: 'idTypeName',width:95},
				{title: '证件号码',key: 'idNumber',width:190},
				{title: '出生日期',key: 'birthday',width:120},
				{title: '国籍',key: 'nationality',width:120},
				{title: '国家/地区',key: 'nationalityArea',width:120},
				{title: '医保',key: 'hasSocialSecurityShow',width:80},
				{title: '医保所在城市',key: 'socialSecurityCity',width:130},
				{title: '职业',key: 'jobType',width:100},
				{title: '入职日期',key: 'entryDate',width:120},
				{title: '起保日期',key: 'effectiveDateStart',width:180},
				{title: '终保日期',key: 'effectiveDateEnd',width:180},
				{title: '保障方案',key: 'insurancePlan',width:120},
				{title: '保费（元）',key: 'premiumAmount',width:110},
				{title: '保障状态',key: 'insuranceStatusName',width:130},
				{title: '结算状态',key: 'settlementStatusName',width:100},
				{title: '参保公司',key: 'companyName',minWidth:200},
				{title: '参保机构',key: 'deptName',width:200,tooltip:true},
				{title: '所属平台',key: 'platformNameShow',minWidth:200},
				{title: '操作人',key: 'userName',width:100},
				{title: '导入时间',key: 'createTime',width:180},
				{title: '导入类型',key: 'importTypeShow',width:180},
				{title: '数据来源',key: 'policySourceShow',width:180},
				{title: '备注',key: 'remarks',width:180},
			],
			total:'',
			importCompany:'',
			selectCompanyShow:false,
			companyList:[],
			importType:'',
			isInDisabledTime, //2024.1.23新增
			deptId:'',
			depList:[],
			depListMod:[],
			depListModId:''
		}
	},
	created () {
		this.getTotal();
		this.getCompanyInfo()
	},
	methods: {
		// 获取总计
		getTotal(){
			this.$axios.post("/guarantee/queryPolicyUserPremium.json",this.params).then(res=>{
				this.total=res
			})
		},
		search() {
			this.$refs.table.getList();
			this.getTotal();
		},
		excel() {
			this.exportToExcel("/guarantee/exportPolicyUser",this.params);
		},
		setDateRange (val,key) {
			this.params[key+"Begin"] = val[0];
			this.params[key+"End"] = val[1];
		},
		// 获取公司信息
		getCompanyInfo(){
			this.$axios.post('/guarantee/queryCompany.json',{
				page:1,
				count:999,
				productCode:this.params.productCode
			}).then(res=>{
				this.companyList=res;
			});
		},
		selectCompanyMoad(val){ 
			// this.deptId=val.deptId 
			if(val){
				this.$axios.post('/guarantee/queryCompanyUserList.admin',{
					companyId:this.importCompany
				}).then(res=>{
					this.depListMod=res 
				});
			}else{
				this.depListMod=[]
				this.depListModId='' 
			}
			
		},
		toImport(type){
			this.importType=type
			this.selectCompanyShow=true;
			this.importCompany='';
			this.companyList.forEach(i=>{
				i.companyNameNew=i.companyName
			})
			this.companyList.forEach(i => {
				if(type=='INIT'){
					if(i.hasAuthPermission!=1) i.companyNameNew=i.companyName+'(无权限)' 
				}else{
					if(i.hasAddPermission!=1) i.companyNameNew=i.companyName+'(无权限)'
				}
			});
		},
		// 选择公司后跳转导入
		confirmSelectCompany(){
			this.selectCompanyShow=false;
			// 加nextTick防止未关闭取消overflow:hidden就跳转导致下一页面不能滚动
			this.$nextTick(()=>{
				if(this.importType=='QUIT'){
					this.$router.push(`/jinkong/import-person/QUIT/${this.importCompany}?deptId=${this.depListModId}`)
				}else{
					this.$axios.post('/guarantee/checkInitButton',{
						companyId:this.importCompany,
						productCode:this.params.productCode
					}).then(res=>{
						// this.$router.push(`/jinkong/import-person/${res?'INIT':'ADD'}/${this.importCompany}`)
						this.$router.push(`/jinkong/import-person/${this.importType}/${this.importCompany}?deptId=${this.depListModId}`)
					});
				}
			})
		},
		// 选择保司
		selectCompany(val){
			if(val){
				this.$axios.post('/guarantee/queryCompanyUserList.admin',{
					companyId:val
				}).then(res=>{
					this.depList=res 
				});
			}else{
				this.depList=[]
				this.$set(this.params,'deptId','')
			}
			
		},
		toCompany(){
			this.selectCompanyShow=false;
			this.$emit('to','Company')
		}
	}
}
</script>
<style scoped lang="less">
.tips{
	font-size: 14px;
	color: red;
	margin-left: 10px;

}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/jinkong/list/Insured.vue